export const GEO_SERVER_BASE_URL = (window.__env__?.REACT_APP_GEO_SERVER_BASE_URL ?? process.env.REACT_APP_GEO_SERVER_BASE_URL) + "/gwc/service/wmts"